import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Typography} from 'views/components';
import {Translate} from 'views/module';
import backend from 'utils/backend';

import HowCareQuiltWorksCard from './information/HowCareQuiltWorksCard';
import ChoosingYourCaregiverCard from './information/ChoosingYourCaregiverCard';
import ScopeOfCareCard from './information/ScopeOfCareCard';
import CareQuiltAdvantageCard from './information/CareQuiltAdvantageCard';
import CostsAndIncludedCard from './information/CostsAndIncludedCard';
import WasHelpfulCard from './information/WasHelpfulCard';
import QuestionCard from './information/QuestionCard';
const InformationalSection = (props) => {
  const {clientRn, user, statusProgressWrap: progressWrap} = props;

  const [loading, setLoading] = React.useState(false);
  const [isHelpful, setIsHelpful] = React.useState(null);
  const [questionInput, setQuestionInput] = React.useState('');
  const [questionSubmitted, setQuestionSubmitted] = React.useState(false);
  const [questionInputError, setQuestionInputError] = React.useState(false);

  const handleIsHelpful = () => {
    setIsHelpful(true);
    progressWrap(async () => {
      const body = {
        clientRelationshipRn: user.userRn,
        articleTitle: 'Homepage | Care Guide | Feedback (Thumbs)',
        feedback: {
          isHelpful: true,
        },
      };
      await backend.clientSupport.createArticleFeedback(clientRn, 'RN:ARTICLE-V1-HELPFUL', body);
    });
  };
  const handleIsNotHelpful = () => {
    setIsHelpful(false);
    progressWrap(async () => {
      const body = {
        clientRelationshipRn: user.userRn,
        articleTitle: 'Homepage | Care Guide | Feedback (Thumbs)',
        feedback: {
          isHelpful: false,
        },
      };
      await backend.clientSupport.createArticleFeedback(clientRn, 'RN:ARTICLE-V1-HELPFUL', body);
    });
  };
  const handleSetQuestionInput = (input) => {
    setQuestionInput(input);
    if (questionInputError) setQuestionInputError(false);
  };
  const handleQuestionSubmit = () => {
    if (questionInput && !questionSubmitted) {
      progressWrap(async () => {
        setLoading(true);
        const body = {
          clientRelationshipRn: user.userRn,
          articleTitle: 'Homepage | Care Guide | Feedback comment',
          feedback: {
            comment: questionInput,
          },
        };
        await backend.clientSupport.createArticleFeedback(clientRn, 'RN:ARTICLE-V1-QUESTION', body);
        setQuestionSubmitted(true);
        setLoading(false);
      });
    } else if (!questionInput) {
      setQuestionInputError(true);
    }
  };

  return (
    <Stack spacing={3} id="info">

      {/* Header */}
      <Stack spacing={1}>
        <Typography component='div' variant='h5'>
          <Translate expression={'dashboard.sections.info.title'}/>
        </Typography>
        <Typography component='div' variant='subtitle' color='text.secondary'>
          <Translate expression={'dashboard.sections.info.subtitle'}/>
        </Typography>
      </Stack>

      {/* How CareQuilt works */}
      <HowCareQuiltWorksCard/>

      {/* Choosing your caregiver */}
      <ChoosingYourCaregiverCard/>

      {/* The scope of care: what a caregiver does */}
      <ScopeOfCareCard/>

      {/* The CareQuilt advantage: more than just a match */}
      <CareQuiltAdvantageCard/>

      {/* Costs and what's included */}
      <CostsAndIncludedCard/>

      {/* Was this helpful */}
      <WasHelpfulCard
        isHelpful={isHelpful ?? null}
        onHelpful={handleIsHelpful}
        onNotHelpful={handleIsNotHelpful}
      />

      {/* Question field */}
      <QuestionCard
        questionInput={questionInput}
        questionInputError={questionInputError}
        questionSubmitted={questionSubmitted}
        onQuestionInputChange={handleSetQuestionInput}
        onQuestionSubmit={handleQuestionSubmit}
        isSubmitting={loading}
      />

    </Stack>
  );
};

InformationalSection.propTypes = {
  clientRn: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
  user: state.user,
});
export default connect(mapStateToProps, dispatch)(InformationalSection);
